import styled from 'styled-components'

import {
  AvgBuyMcDistributionTitle,
  AvgBuyMcDistributionTrack,
} from './avg-buy-mc-distribution-column'
import { AvgBuyMcDistributionCommon } from './avg-buy-mc-distribution-common'

import type { ClassNameProps } from '@root/shared/react'

type Props = {
  columns: ReadonlyArray<{
    title: string
    count: string | number
    percentage: React.ReactNode
    percentageValue: number
  }>
} & ClassNameProps

export const AvgBuyMcDistribution = (props: Props) => {
  return (
    <AvgBuyMcDistributionCommon className={props.className}>
      <Main columns={props.columns.length}>
        {props.columns.map((column, i) => (
          <AvgBuyMcDistributionTitle key={i} {...column} />
        ))}
        {props.columns.map((column, i) => (
          <AvgBuyMcDistributionTrack key={i} {...column} />
        ))}
      </Main>
    </AvgBuyMcDistributionCommon>
  )
}

const Main = styled.div<{ columns: number }>`
  display: grid;

  grid-template-columns: repeat(${({ columns }) => columns}, 1fr);
  grid-template-rows: auto 1fr;
  gap: 8px;
`
